import React, { useEffect , useContext } from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';
import {Context} from "../../../store/reducer";

/**
 * 既存盛土等（法第4条第1項）のポップアップ
 *
 * 
 * @param spot
 * @param latitude
 * @param longitude
 * @param menu
 * @param draggable
 * @param option
 * @param ignored 表示しない列
 * @returns {JSX.Element|null}
 * @constructor
 */
const Component = ({spot, latitude, longitude, menu, draggable=false, option, ignored=[]}) => {
  
  const { state } = useContext(Context);

  const icon = menu2icon[option.id]

  const iconUrl = new L.Icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconSize: [35, 35],
    iconAnchor: [17, 23],
    popupAnchor: [0, -50]
  });

  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const handleSpotData = (menu, spot, option) => {

    let ret = []

    ret.push(<dl className='dl-list is-modal-spot'><dd><a href={"https://www.pref.hiroshima.lg.jp/soshiki/262/moridokeihatsu.html"} target={"_blank"}>既存盛土等（法第4条第1項）</a></dd></dl>)

    ret.push(<dl className='dl-list is-modal-spot'><dt>整理番号</dt><dd>{spot["整理番号"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>所在市町</dt><dd>{spot["所在市町"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>土地の所在地及び地番</dt><dd>{spot["土地の所在地及び地番"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>調査結果</dt><dd>{spot["調査結果"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>調査年度</dt><dd>{spot["調査年度"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>備考</dt><dd>{spot["備考"]}</dd></dl>)

    return ret
  }

  if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){

    return (
      <>
        <Marker
          position={[latitude, longitude]}
          icon={iconUrl}
        >
          <Popup autoPan={false}  minHeight={300} maxHeight={400} minWidth={500} closeOnClick>
            {
              handleSpotData(menu, spot, option)
            }
          </Popup>
        </Marker>

      </>
    );
  }else{
    return null
  }
}

export default Component;
